<template>
  <div style="width:100%">
    <v-row class="ml-3 mt-n9 mb-3">
      <div class='headline'>Подписка на электронную рассылку квитанций</div>
    </v-row>
    <v-row align="center" justify="center" class="subtitle-1">
      <v-col align="center" justify="center">
        <v-card align="start" outlined width="1100" class="pa-4">Для подписки на электронную рассылку квитанций введите номер лицевого счёта, а также логин и пароль личного кабинета.<br>Если вы не зарегистрированы в личном кабинете, нажмите на кнопку "Зарегистрироваться".</v-card>
      </v-col>
    </v-row>
    <v-row align="center" justify="center">
      <v-col class='col-12' align="center" justify="center">
        <v-card class="pl-9 pt-10 pr-9 pb-3" width="400">
          <auth :showOAuth="false" :subscribe="true"></auth>
        </v-card>
      </v-col>
    </v-row>
    <request-dialog v-model="searchDialog" message="Выполняется запрос..." />
  </div>
</template>
<script>
import { downloadFile, convertDate, parseDate, getTodayDate, cleanNumber, wrapsNumber } from '@/utils'
import { mapGetters } from 'vuex'

export default {
  name: 'InstructionView',

  components: {
    auth: () => import(
      '@/components/core/Auth'
    ),
    settings: () => import(
      '@/views/SettingsView'
    )
  },

  data: () => ({
    searchDialog: false,
    dialog: false,

  }),
  computed: {
    ...mapGetters({
      isLoggedIn: 'user/isAuthenticated',
      userLogin: 'user/userLogin',
      userAccounts: 'user/userAccounts'
    })
  },

  created() {
    if (this.isLoggedIn) this.$router.push('/settings')
  },

  methods: {

  }
}

</script>
<style scoped>
.v-text-field {
  max-width: 300px;
  font-size: 15px;
}

.v-btn.picker {
  margin-top: 16px;
  padding-left: 10px;
  padding-right: 10px;
}

@media screen and (-ms-high-contrast: active),
(-ms-high-contrast: none) {
  .v-data-footer__select {
    display: none !important;
    /*margin-right: 160px!important;*/
  }

  .v-data-footer__pagination {
    display: none !important;
  }

  .container--fluid {
    max-width: 90%;
  }
}

.heat-list {
  height: 200px;
  overflow-y: auto;
  border: 1px solid rgb(193 193 193);
  /*min-width: 500px;*/
}

.instruction-img {
  border: solid lightgrey 1px;
  max-width: 700px !important;
}
</style>